import { Input, ActionButton } from '@emerald-works-nova/components'
import { useEvent, useEventsOnViewLoad } from '@emerald-works/react-event-bus-client'
import { Box, Button, Dialog, DialogTitle, Grid, Typography, InputLabel, MenuItem, FormControl, Select, CircularProgress } from '@mui/material'
import { useForm } from 'react-hook-form'
import React from 'react'
import { useStyles } from './style'
import { useTenantFormContext } from '../../tenant-form-context'
import { BannerStatic } from '../../../../components'

export const AddCustomAttr = React.memo(({
  open,
  onClose = () => { },
  getCustomAttributeList = () => { }
}) => {
  const classes = useStyles()
  const { tenant } = useTenantFormContext()
  const { userPoolId } = tenant
  const [type, setType] = React.useState('String')

  const [createCustomAttribute] = useEvent([
    {
      eventName: 'tenantAddSSOCustomAttribute'
    }
  ])

  useEventsOnViewLoad(() => {
    createCustomAttribute.registerAdhocOnSuccessListener(() => {
      BannerStatic.show({ label: 'New Custom Attribute created successfully.' })
      getCustomAttributeList.trigger({ userPoolId })
      handleClose()
    })
    createCustomAttribute.registerAdhocOnErrorListener(() => {
      BannerStatic.show({ label: 'Error creating new Custom Attribute.', isError: true })
    })
  }, [createCustomAttribute, userPoolId])

  const handleChange = (event) => {
    setType(event.target.value)
  }

  const handleCreate = () => {
    const customAttrName = form.getValues('customAttrName')
    createCustomAttribute.trigger({
      attributeName: customAttrName,
      attributeType: type,
      userPoolId
    })
  }

  const handleClose = () => {
    form.reset()
    onClose()
  }

  const form = useForm({ mode: 'onChange' })
  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }} aria-labelledby='manage-category-title'>
      <DialogTitle id='manage-category-title' className={classes.dialogTitle}>
        <Grid container className={classes.actionBtnCtn}>
          <Grid item xs={8}>Add Custom Attribute</Grid>
        </Grid>
      </DialogTitle>
      {!createCustomAttribute.isWorking
        ? (
          <>
            <Typography variant='caption'>Personalize the sign-up experience by adding up to 50 attributes.</Typography>
            <Typography variant='caption'>Custom attribute names can't be changed after a user pool has been created.</Typography>
            <Grid className={classes.inputGroup} container>
              <Input
                autoFocus
                control={form.control}
                label='Enter a name for custom attribute'
                name='customAttrName'
                error='Title is required'
                maxLength={20}
              />
              <FormControl fullWidth className={classes.inputStyle}>
                <InputLabel id='demo-simple-select-label'>Select the type of attribute</InputLabel>
                <Select
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={type}
                  label='Select the type of attribute'
                  onChange={handleChange}
                >
                  <MenuItem value='String'>String</MenuItem>
                  <MenuItem value='Number'>Number</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Box mt={3} mb={2}>
              <Grid container item xs={4} justifyContent='flex-end' style={{ float: 'inline-end' }}>
                <Button
                  color='primary'
                  data-test='cancel-button'
                  className={classes.cancelBtn}
                  onClick={handleClose}
                > Cancel
                </Button>
                <ActionButton
                  variant='primary'
                  dataTest='save-button'
                  className={classes.saveBtn}
                  onClick={handleCreate}
                // disabled={disabled}
                >
                  Create
                </ActionButton>
              </Grid>
            </Box>
          </>
        )
        : (
          <Box className={classes.loading}>
            <CircularProgress />
          </Box>
        )}
    </Dialog>
  )
})
